/** Option affichable : clé technique, libellé, couleur. */
export interface ColoredOption<K extends string = string> {
  key: K;
  label: string;
  color: string;
}
export const COLORS = [
  '#2277BD',
  '#1D9E75',
  '#EF9F27',
  '#D85A30',
  '#D4537E',
  '#378ADD',
  '#639922',
  '#534AB7',
];
